import React from 'react';
import { resolveProductMediaUrl } from '../../../services/apiService';

export default function DispatchPhotoSection({
  dispatchPhoto,
  onApprove,
  onPass,
  approving,
  passing,
}) {
  if (!dispatchPhoto?.url) return null;

  const src = resolveProductMediaUrl(dispatchPhoto.url);

  return (
    <section className="rounded-2xl border border-emerald-700/50 bg-emerald-950/20 p-4 sm:p-5">
      <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-emerald-400">
        Pre-dispatch photo
      </p>
      <p className="mt-2 text-sm text-emerald-100/90">
        Seller sent a photo of the exact panel. Review before payment.
      </p>

      <div className="mt-4 overflow-hidden rounded-xl border border-slate-700/60 bg-slate-900">
        <img
          src={src}
          alt="Pre-dispatch panel photo from seller"
          className="max-h-80 w-full object-contain"
        />
      </div>

      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <button
          type="button"
          onClick={onApprove}
          disabled={approving || passing}
          className="rounded-xl bg-emerald-600 px-5 py-3.5 text-sm font-bold text-white hover:bg-emerald-500 disabled:opacity-50"
        >
          {approving ? 'Please wait…' : 'Approve — Ship this'}
        </button>
        <button
          type="button"
          onClick={onPass}
          disabled={approving || passing}
          className="rounded-xl border-2 border-red-600/60 bg-red-950/30 px-5 py-3.5 text-sm font-bold text-red-300 hover:bg-red-950/50 disabled:opacity-50"
        >
          {passing ? 'Please wait…' : 'Pass — not what I need'}
        </button>
      </div>
    </section>
  );
}
